import React, { useEffect, useState } from 'react'
import { Spin } from 'antd'
import { Helmet } from 'react-helmet'
import { connect } from 'react-redux'

const mapStateToProps = ({ user, settings, register }) => ({
  firstName: user.firstName,
  lastName: user.lastName,
  email: user.email,
  isMobileView: settings.isMobileView,
  bmUrl: register.meetingUrl,
})

const BookaMeeting = ({ isMobileView, firstName, lastName, email, bmUrl }) => {
  const [loadMeetingPage, setLoadMeetingPage] = useState(true)

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://static.hsappstatic.net/MeetingsEmbed/ex/MeetingsEmbedCode.js'
    script.async = true
    document.body.appendChild(script)
    script.addEventListener('load', cvv => {
      if (window.hbspt) {
        console.log(cvv)
      }
    })
    script.onload = () => {
      setLoadMeetingPage(false)
    }
  }, [])

  const cardSubDescription = () => {
    return (
      <div>
        <div
          className="meetings-iframe-container"
          data-src={`${bmUrl}?embed=true&firstname=${firstName}&lastname=${lastName}&email=${email}`}
          style={{
            width: isMobileView ? 100 : 780,
            height: isMobileView ? 500 : 650,
          }}
        />
      </div>
    )
  }

  return (
    <>
      <Helmet title="book a meeting" />
      <Spin spinning={loadMeetingPage}>{cardSubDescription()}</Spin>
    </>
  )
}

export default connect(mapStateToProps)(BookaMeeting)
